var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "M1.1 68.846l13.005 13.003L50 45.956 85.895 81.85 98.9 68.846 63.005 32.951l.52-.52L50 19.426h-.52L36.474 32.431v.52L1.1 68.846z"
  })));
};
export default SvgArrowUp;